import axios from "axios";

import { getApiUrl } from "./apiPaths";

export const vehicleRouteApi = axios.create({
  baseURL: `${getApiUrl()}/vehicle-routes`,
});
